import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { WallboardsService } from '../../wallboards.service';
import { WVData, WVMain } from '../wallboard-view.model';
import { ImageSettingsTransferObj, ModuleType } from '../../wallboards.model';

@Component({
  selector: 'cv-wallboard-view-image',
  templateUrl: './wallboard-view-image.component.html',
  styleUrls: ['./wallboard-view-image.component.scss']
})
export class WallboardViewImageComponent implements OnInit, OnDestroy {
    @Input() firstSlide;

    public wvf: WVMain;
    public wvif: WVData;
    public imageState: ImageSettingsTransferObj;
    public imageAspect: number | string;

    public imgHeight: number | string;
    public imgWidth: number | string;

    private isDestroyed: boolean = false;

    get moduleKey(): string {
        return this.wvif.Slide.WallboardModuleDetails[0].WallboardModuleKey ?? "";
    }

    constructor(
        private service: WallboardViewService,
        public wallboardsService: WallboardsService,
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvif = this.service.WVImage;

        this.wvf.RunSlide = this.firstSlide;

        this.imgHeight = Math.floor($("#wallboardViewArea").height()) - 34;
        this.imgWidth = Math.floor($("#wallboardViewArea").width()) - 34;

        this.service.loadModuleState(ModuleType.Image, this.wvf.WallboardCreatorID, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            this.imageState = response.imgObj;

            this.wallboardsService.getImageAspect(this.imageState.UploadedImageID).then(response => {
                if (this.isDestroyed)
                    return;

                this.imageAspect = response;

                if (+this.imgWidth >= +this.imgHeight * +this.imageAspect)
                    this.imgWidth = "auto";
                    //this.imgHeight = "auto";
                else
                    this.imgHeight = "auto";
                    //this.imgWidth = "auto";

                if (this.firstSlide)
                    this.wvf.FirstSlideReady = true;
                else
                    this.wvf.NextSlideReady = true;
            });
        });
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }
}
